import React from "react";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { AppBar, Toolbar } from "@material-ui/core";

import LogoFooter from '../../../assets/images/logo-footer.png';
import "./style.scss";
import Translate from "../../../i18n/translationComponent";

const appbarTheme = createTheme({
	palette: {
		primary: {
			main: "#fff",
		},
	},
});

const AppFooter = () => {
	return (
		<div className="footer root">
			<Container className="footer-content">
				<ThemeProvider theme={appbarTheme}>
					<AppBar position="static" className="appbar-footer">
						<Toolbar className="footer">
							<div className="logo-footer">
								<img src={LogoFooter} alt="gutenberg cert logo" className="CertLogo" />
							</div>
							<section className="footer-menuRight">
								<div className="footer-options">
									<a href="https://www.gutenbergcerts.com/terms-of-service" className="itemFooter" target="_blank" rel="noreferrer">
										<Translate text="Terms of Service" />
									</a>
									<a href="https://www.gutenbergcerts.com/privacy-data-protection" className="itemFooter" target="_blank" rel="noreferrer">
										<Translate text="Privacy & Data Protection" />
									</a>
									<a href="https://www.gutenbergcerts.com/support" className="itemFooter" target="_blank" rel="noreferrer">
										<Translate text="Customer Support" />
									</a>
									<a href="https://www.gutenbergcerts.com/help-center" className="itemFooter" target="_blank" rel="noreferrer">
										<Translate text="Help Center" />
									</a>
								</div>
								<div className="copyright">Copyright @{new Date().getFullYear()} Gutenberg Certs. All rights reserved.</div>
							</section>
						</Toolbar>
					</AppBar>
				</ThemeProvider>
			</Container>
		</div>
	);
};

export default AppFooter;
